import { TESSearchField, TESSearchFields } from '../definitions';

export const huntingtonExtendedSearchFields = (searchFields?: TESSearchFields): TESSearchField[] => [
  {
    name: 'myServiceInUse',
    type: 'Radio',
    options: ['yes', 'no'],
  },
  {
    name: 'includeDeceased',
    type: 'Radio',
    options: ['yes', 'no'],
  },
];
